import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=74cc232c&scoped=true&"
import script from "@/scripts/Password/Reset/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Password/Reset/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc232c",
  null
  
)

export default component.exports